<template>
  <section class="py-6">
    <b-container>
      <h2 class="h2 font-weight-900 pb-3 pt-3 d-lg-none">OUTILS</h2>
      <b-row align-v="center" class="content-center">
        <b-col lg="4" :key="item.id" v-for="(item, index) in tools" v-if="index != 7" class="mb-lg-4 mb-3">
          <b-card :class="item.note?'tools note':'tools'">
            <b-link :href="data.tools[index].url" target="_blank">
              <span class="h2 font-weight-900 mb-0 d-none d-lg-block" v-html="$t(item.title)"></span>
              <b-row align-v="center" class="details">
                <b-col align="center" align-v="center" cols="2" sm="4" class="pl-0 pr-0">
                  <i class="icon"><b-img class="" alt="..." :src="item.icon" /></i>
                </b-col>
                <b-col align="left" align-v="center" cols="10" sm="8" class="pl-0">
                  <span class="h3 font-weight-900 mb-0 d-lg-none" v-html="$t(item.title)"></span>
                  <p v-html="$t(item.description)"></p>
                </b-col>
                <p class="ntf" v-if="$t(item.note)"><span v-html="$t(item.note)"></span></p>
              </b-row>
            </b-link>
          </b-card>
        </b-col>
        <b-col lg="4" class="mb-lg-4 mb-3">
          <b-card class="tools password">
            <b-row align-v="center">
              <b-col align="center" align-v="center" cols="2" lg="0" sm="4" class="pl-0 pr-0">
              </b-col>
              <b-col align="left" align-v="center" cols="10" lg="12" sm="8" class="pl-0">
                <span class="h2 font-weight-900 mb-0 pl-lg-3" v-html="$t(password.title)"></span>
                <p class="pl-lg-3" v-html="$t(password.description)"></p>
              </b-col>
            </b-row>
            <b-row align-v="center" class="details">
              <b-col align="center" align-v="center" cols="6" sm="6" class="pl-0 pr-0">
                <b-link :href="data.password.url_astek" target="_blank">
                  <i class="icon-sm zoom-in"><b-img class="" alt="..." :src="password.icon" /></i>
                  <br/>
                  <b-img class="small" alt="..." :src="password.passwordicon.astek" />
                </b-link>
              </b-col>
              <b-col align="center" align-v="center" cols="6" sm="6" class="pl-0 pr-0">
                <b-link :href="data.password.url_intitek" target="_blank">
                  <i class="icon-sm zoom-in"><b-img class="" alt="..." :src="password.icon" /></i>
                  <br/>
                  <b-img class="small" alt="..." :src="password.passwordicon.intitek" />
                </b-link>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col lg="4" class="mb-lg-4 mb-3">
          <b-card class="tools">
            <b-link :href="data.tools[7].url" target="_blank">
              <span class="h2 font-weight-900 mb-0 d-none d-lg-block" v-html="$t(tools[7].title)"></span>
              <b-row align-v="center" class="details">
                <b-col align="center" align-v="center" cols="2" sm="4" class="pl-0 pr-0">
                  <i class="icon"><b-img class="" alt="..." :src="tools[7].icon" /></i>
                </b-col>
                <b-col align="left" align-v="center" cols="10" sm="8" class="pl-0">
                  <span class="h3 font-weight-900 mb-0 d-lg-none" v-html="$t(tools[7].title)"></span>
                  <p v-html="$t(tools[7].description)"></p>
                </b-col>
              </b-row>
            </b-link>
          </b-card>
        </b-col>        
      </b-row>
    </b-container>
  </section>
</template>

<script>
import Vue from "vue";
import data from '../../../datas';
export default {
  name: 'Tools',
  data() {
    return {
      data,
      tools: [
        {
          id: 1,
          title: "tools.app-1.title",
          description: "tools.app-1.description",
          icon: "./img/theme/tools/helpdesk.png",
          note: "tools.app-1.note"
        },
        {
          id: 2,
          title: "tools.app-2.title",
          description: "tools.app-2.description",
          icon: "./img/theme/tools/simus.png"
        },
        {
          id: 3,
          title: "tools.app-3.title",
          description: "tools.app-3.description",
          icon: "./img/theme/tools/webmail.png"
        },
        {
          id: 4,
          title: "tools.app-4.title",
          description: "tools.app-4.description",
          icon: "./img/theme/tools/share.png"
        },
        {
          id: 6,
          title: "tools.app-6.title",
          description: "tools.app-6.description",
          icon: "./img/theme/tools/myskills.svg"
        },
        {
          id: 7,
          title: "tools.app-7.title",
          description: "tools.app-7.description",
          icon: "./img/theme/tools/brand_center.png"
        },
        {
          id: 8,
          title: "tools.app-8.title",
          description: "tools.app-8.description",
          icon: "./img/theme/tools/kit_management_de_projet.png"
        },
        {
          id: 9,
          title: "tools.app-9.title",
          description: "tools.app-9.description",
          icon: "./img/theme/tools/emisys_certified_mase.png"
        },
        {
          id: 10,
          title: "tools.app-10.title",
          description: "tools.app-10.description",
          icon: "./img/theme/tools/N2F.png"
        }
      ],
      password: {
        id: 5,
        title: "tools.app-5.title",
        description: "tools.app-5.description",
        icon: "./img/theme/tools/password.png",
        ispassword:true,
        passwordicon:{
          astek:"./img/brand/logo_astek_black.png",
          intitek:"./img/brand/logo_intitek_password.png"
        }
      }
    }
  }
};
</script>

<style>
.password .card-body {
  padding: 1.5rem 1.5rem .2rem 1.5rem;
}
</style>
